import { authService } from '../..';
import { User } from '@microsoft/microsoft-graph-types-beta';

export async function FetchMe(): Promise<User | undefined> {
  const accessToken = await authService.getGraphTokenSilent();
  let user: User | undefined;
  try {
    const headers = new Headers();
    headers.set('Authorization', `Bearer ${accessToken}`);
    console.log('FetchMe accessToken', accessToken);
    console.log('FetchMe headers', headers);
    const response = await fetch('https://graph.microsoft.com/beta/me', { method: 'get', headers });
    console.log('FetchMe response', response);
    if (response.ok) {
      user = await response.json();
    }
  } catch {
    //
  }
  return user;
}
